import React, { useEffect, useState } from "react";
import { Container, Grid } from "@mantine/core";

import { TopProducts } from "./topProducts";
import { TopListTable } from "components/SupplierDashboard/topLitTable";

const ManagerDashboard = ({ data, selectedBadge, setSelectedBadge }) => (
  <Container
    style={{ marginTop: "10px", marginLeft: "0px", maxWidth: "1200px" }}
  >
    <Grid>
      <Grid.Col span={8}>
        <TopListTable
          data={data?.top_products || []}
          title="Top Products"
          headers={["Name", "Orders", "Sales"]}
          dataKeys={["name", "total_orders", "total_sales"]}
          selectedBadge={selectedBadge}
          setSelectedBadge={setSelectedBadge}
        />
      </Grid.Col>
    </Grid>
  </Container>
);

export default ManagerDashboard;
